// extracted by mini-css-extract-plugin
export default {"googleDrive":"styles_googleDrive__RF4RQ","icon":"styles_icon__mYSlT"};